import React from "react";
import { SubSection } from "context/BlogContext";

interface PreviewProductProps {
  subSection: SubSection;
}

const PreviewProduct: React.FC<PreviewProductProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "product" && (
        <div className="flex gap-5 pt-10">
          <div className="h-28 w-28 rounded-xl overflow-hidden">
            <img src={subSection?.attrs?.image} alt="" />
          </div>
          <div className="pt-5">
            <div>{subSection?.attrs?.title}</div>
            <div>{subSection?.attrs?.slug}</div>
          </div>
        </div>  
      )}
    </div>
  );
};

export default PreviewProduct;
